import { Button, Modal, ProgressBar } from 'avo-ui'
import icX from 'assets/images/ic-x.svg'
import { formatDateMoment } from 'utils/utils'
import icWarning from 'assets/images/ic-warning.svg'

const VARIABLE_COUNT = [
    {
        name: 'Total Data',
        key: 'total',
        color: 'text-blue-60',
    },
    {
        name: 'Ongoing',
        key: 'processing',
        color: 'text-yellow-60',
    },
    {
        name: 'Completed',
        key: 'completed',
        color: 'text-green-600',
    },
    {
        name: 'Failed',
        key: 'failed',
        color: 'text-red-60',
    },
]

export const SyncProduct = ({ 
    show, 
    onHide, 
    selectedCount,
    onCalculate, 
    progressDetail, 
    percentage, 
    isCalculate 
}) => {
    return (
        <Modal dialogClassName={'w-[450px]'} contentClassName={'rounded-xl'} show={show} onHide={onHide}>
            <>
                <div className={'flex flex-row px-6 py-5 items-center justify-between'}>
                    <div />
                    <p className={'font-bold text-blue-90 text-lg mt-2'}>Sync Product</p>
                    <img className={'w-5 -mt-8 cursor-pointer'} src={icX} alt='ic-x' onClick={onHide} />
                </div>
                {!isCalculate || progressDetail?.status === 'idle' ? (
                    <div className={'flex flex-col space-y-6'}>
                        <div className={'flex flex-col space-y-3 items-center px-10 text-center'}>
                            <img src={icWarning} alt={'ic-warning'} className={'w-12 h-12'} />
                            <p className={'text-neutral-70'}>
                                Apakah Anda yakin ingin melakukan sinkronisasi data product & gift website MSBB ke Ginee
                                ?
                            </p>
                            <p className={`font-bold ${selectedCount ? 'block' : 'hidden'}`}>{selectedCount} Data dipilih</p>
                            <p className={'font-bold'}>
                                Last sync: {formatDateMoment(progressDetail?.last_sync_at, 'YYYY/MM/DD HH:mm')}
                                {!!progressDetail?.count?.failed && `, Jumlah Gagal ${progressDetail?.count?.failed}`}
                            </p>
                        </div>
                        <div className={'px-6 py-3 flex space-x-2 justify-center'}>
                            <Button className={'w-[150px]'} type={'outline'} title={'Cancel'} onClick={onHide} />
                            <Button className={'w-[150px]'} title={'Sync'} onClick={onCalculate} />
                        </div>
                    </div>
                ) : (
                    <div className={'flex flex-col space-y-10 py-5 justify-center items-center'}>
                        <div className={'flex space-x-6'}>
                            {VARIABLE_COUNT.map((item, index) => (
                                <p key={index} className={`font-medium capitalize ${item?.color}`}>
                                    {item?.name}: {progressDetail?.count?.[item?.key] || 0}
                                </p>
                            ))}
                        </div>
                        <ProgressBar className={'w-2/3'} percentage={percentage} />
                        <p className={'font-bold text-lg text-primary-60'}>Progress in {percentage}%</p>
                    </div>
                )}
            </>
        </Modal>
    )
}
